import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsReceivingPensionOrPayout } from '../../../global/ducks/person-prc-api';
import { DemographicsContext } from '../../../global/models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { setIsReceivingPensionOrPayout } from '../features/personal-info/document-upload-slice';

export function useIsReceivingPensionOrPayout(clientId: string): boolean {
    const dispatch = useDispatch();
    const app = useContext(DemographicsContext);    
    const isReceivingPensionOrPayout = useSelector<TcsmStates, any>(state => state.documentUpload[app]?.isReceivingPensionOrPayout);

    useEffect(() => {
        if (clientId && isReceivingPensionOrPayout === null) {
            dispatch(getIsReceivingPensionOrPayout(
                clientId, 
                (remoteData)=>{
                    let remoteIsReceivingPensionOrPayout = false;

                    if (remoteData?.status?.code === 'SUCCESS'){
                        remoteIsReceivingPensionOrPayout = remoteData?.data?.active_pension;
                    }

                    dispatch(setIsReceivingPensionOrPayout(remoteIsReceivingPensionOrPayout === undefined ? false : remoteIsReceivingPensionOrPayout, app));
                }, 
                () => {
                    dispatch(setIsReceivingPensionOrPayout(false, app));
                }));
        }
    }, [clientId, isReceivingPensionOrPayout]);

    return isReceivingPensionOrPayout;
}
